"use strict";

angular.module("core").component("invoiceDetails", {
    controllerAs: "invoiceDetailsCtrl",
    templateUrl: require("./invoice-details.component.html"),
    bindings: {
        invoiceService: "<?",
        showPaymentButton: "<?",
        showEmailButton: "<?",
        showAttachmentButton: "<?",
        showDeleteButton: "<?"
    },
    controller: function(
        $scope, $state, $stateParams, $rootScope, ModalService, gettextCatalog, IS_MOBILE, InvoiceService, UserService,
        InvoiceStatusService, PaymentMethodsService, PaymentService, INVOICE_ATTACHMENTS_MAX, PAYMENT_STATUS
    ) {
        $scope.INVOICE_ATTACHMENTS_MAX = INVOICE_ATTACHMENTS_MAX;
        $scope.PAYMENT_STATUS = PAYMENT_STATUS;

        if (this.invoiceService) {
            $scope.invoiceService = this.invoiceService;
        }
        else {
            $scope.invoiceService = InvoiceService;
        }

        UserService.isUserFetched().then(function onSuccess(user) {
            if (user) {
                $scope.dedicatedVendorId = user.dedicated_vendor_id;
                $scope.isUserCanPay = user.is_user_can_pay;
            }
        });

        $scope.statusNamesLocalized = InvoiceStatusService.getStatusNamesLocalized();
        $scope.paymentStatusNamesLocalized = PaymentService.getStatusNamesLocalized();
        $scope.methodChoicesLocalized = PaymentMethodsService.getMethodChoicesLocalized();
        $scope.otherChargesLocalized = InvoiceService.getOtherChargesLocalized();
        $scope.taxesLocalized = InvoiceService.getTaxesLocalized();

        $scope.isMobile = IS_MOBILE;
        $scope.invoiceId = $stateParams.id;
        $scope.invoice = $scope.invoiceService.get($scope.invoiceId);
        $scope.previousState = $rootScope.fromState.name;
        $scope.previousParams = $rootScope.fromParams;

        if ($scope.previousState === "") {
            $scope.previousState = "home";
            $scope.previousParams = null;
        }

        this.onAddAttachment = function() {
            $scope.invoice.$get($stateParams.id);
        }

        this.isDisabledPayButton = function() {
            return !$scope.isUserCanPay;
        };

        this.seeUnpaidInvoice = function() {
            if (this.isDisabledPayButton()) {
                return;
            }

            $state.go("payment", {selected: $scope.invoiceId});
        }

        this.getDisabledButtonPayHelpTipHtmlContent = function() {
            return gettextCatalog.getString("Your owner didn't grants you access to the payment feature.");
        };
    }
});



//////////////////
// WEBPACK FOOTER
// ./core/invoice/invoice-details.component.js
// module id = 521
// module chunks = 0